import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { useMeContext } from '~/modules/me/useMeContext';

const useRefetchAttachmentInfo = () => {
  const apolloClient = useApolloClient();
  const { featureFlags } = useMeContext();

  const refetchAttachmentInfo = useCallback(() => {
    if (featureFlags.isPsaPraaResourceMatchingEnabled) {
      const attachmentInfoQuery = [
        ...apolloClient.getObservableQueries().values()
      ].find(query => query.queryName === 'attachmentInfo');

      if (attachmentInfoQuery) {
        apolloClient.refetchQueries({
          include: ['attachmentInfo']
        });
      }
    }
  }, [apolloClient, featureFlags]);

  return {
    refetchAttachmentInfo
  };
};

export default useRefetchAttachmentInfo;
